export const reOrgConstructionMaterialPricePeriodChangeConstants = {
	GetPaged: {
		FAILURE : 'GET_PAGED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_PAGED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_PAGED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	GetListPeriodRegionReOrg: {
		FAILURE : 'GET_LIST_PERIOD_REGION_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_LIST_PERIOD_REGION_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_LIST_PERIOD_REGION_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	GetHistoryPaged: {
		FAILURE : 'GET_PRICE_HISTORY_PAGED_FAILURE',
		REQUEST : 'GET_PRICE_HISTORY_PAGED_REQUEST',
		SUCCESS : 'GET_PRICE_HISTORY_PAGED_SUCCESS'
	},
	GetPricesByPeriodsPaged: {
		FAILURE : 'GET_PRICE_BY_PERIODS_PAGED_FAILURE',
		REQUEST : 'GET_PRICE_BY_PERIODS_PAGED_REQUEST',
		SUCCESS : 'GET_PRICE_BY_PERIODS_PAGED_SUCCESS'
	},
	GetMaterialPricesByPeriods: {
		FAILURE : 'GET_MATERIAL_PRICES_BY_PERIODS_PAGED_FAILURE',
		REQUEST : 'GET_MATERIAL_PRICES_BY_PERIODS_PAGED_REQUEST',
		SUCCESS : 'GET_MATERIAL_PRICES_BY_PERIODS_PAGED_SUCCESS'
	},
	GetExampleFile: {
		FAILURE : 'GET_FILE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_FILE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_FILE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	GetByFile: {
		FAILURE : 'GET_BY_FILE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_BY_FILE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_BY_FILE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	GetOrgExampleFile: {
		FAILURE : 'GET_ORG_EXAMPLE_FILE_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_ORG_EXAMPLE_FILE_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_ORG_EXAMPLE_FILE_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	SubmitReOrgPricesForPeriod: {
		FAILURE : 'SUBMIT_REORG_PRICE_FOR_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'SUBMIT_REORG_PRICE_FOR_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'SUBMIT_REORG_PRICE_FOR_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	GetOrgNotInputMaterials: {
		FAILURE : 'GET_REORG_NOT_INPUT_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_REORG_NOT_INPUT_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_REORG_NOT_INPUT_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	Create: {
		FAILURE : 'CREATE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'CREATE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'CREATE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	Update: {
		FAILURE : 'UPDATE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'UPDATE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'UPDATE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	Delete: {
		FAILURE : 'DELETE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'DELETE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'DELETE_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	DeleteSelectedPrices: {
		FAILURE : 'DELETE_SELECTED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'DELETE_SELECTED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'DELETE_SELECTED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	DeleteFilteredPrices: {
		FAILURE : 'DELETE_FILTERED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_FAILURE',
		REQUEST : 'DELETE_FILTERED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_REQUEST',
		SUCCESS : 'DELETE_FILTERED_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE_SUCCESS'
	},
	CLEAR: 'CLEAR_REORG_CONSTRUCTION_MATERIAL_PERIOD_PRICE_CHANGE'
}